export default function counterWidget(editor) {
  editor.DomComponents.addType('eb-counter', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-counter'
    },
    model: {
      defaults: {
        name: 'Counter',
        tagName: 'div',
        droppable: false,
        attributes: { 'data-gjs-type': 'eb-counter', 'data-target': '1000', 'data-duration': '2000' },
        style: {
          'text-align': 'center',
          'padding': '20px',
        },
        components: `
          <div class="eb-counter-number" style="font-size:48px;font-weight:700;color:#667eea;line-height:1;">1000</div>
          <div style="font-size:14px;color:#666;margin-top:8px;text-transform:uppercase;letter-spacing:1px;">Happy Clients</div>
        `,
        traits: [
          { type: 'number', name: 'data-target', label: 'Target Number', changeProp: true, default: 1000 },
          { type: 'number', name: 'data-duration', label: 'Duration (ms)', default: 2000 },
          { type: 'text', name: 'data-suffix', label: 'Suffix (e.g., +, %)' },
          { type: 'text', name: 'data-prefix', label: 'Prefix (e.g., $)' },
        ],
      },
      init() {
        this.on('change:attributes:data-target', this.updateDisplay)
      },
      updateDisplay() {
        const target = this.getAttributes()['data-target'] || '1000'
        const prefix = this.getAttributes()['data-prefix'] || ''
        const suffix = this.getAttributes()['data-suffix'] || ''
        const numEl = this.components().at(0)
        if (numEl) numEl.set('content', `${prefix}${target}${suffix}`)
      },
      toHTML() {
        const attrs = this.getAttributes()
        const target = attrs['data-target'] || '1000'
        const duration = attrs['data-duration'] || '2000'
        const prefix = attrs['data-prefix'] || ''
        const suffix = attrs['data-suffix'] || ''
        const style = this.getStyle()
        const styleStr = Object.entries(style).map(([k, v]) => `${k}:${v}`).join(';')
        return `<div data-gjs-type="eb-counter" data-target="${target}" data-duration="${duration}" style="${styleStr}">
          <div class="eb-counter-number" style="font-size:48px;font-weight:700;color:#667eea;line-height:1;">${prefix}0${suffix}</div>
          <div style="font-size:14px;color:#666;margin-top:8px;text-transform:uppercase;letter-spacing:1px;">${this.components().at(1)?.get('content') || 'Counter'}</div>
          <script>
          (function(){var el=document.currentScript.parentElement.querySelector('.eb-counter-number');var t=${target},d=${duration},p='${prefix}',s='${suffix}';var start=0,step=Math.ceil(d/t);var timer=setInterval(function(){start+=Math.ceil(t/(d/16));if(start>=t){start=t;clearInterval(timer);}el.textContent=p+start.toLocaleString()+s;},16);})();
          ${'</script>'}
        </div>`
      },
    },
  })

  editor.BlockManager.add('eb-counter', {
    label: 'Counter',
    category: 'General',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M4,6V18H20V6H4M13,7.5H18V9.5H13V7.5M13,11H18V13H13V11M13,14.5H18V16.5H13V14.5M6,7.5H11V16.5H6V7.5Z"/></svg>',
    content: { type: 'eb-counter' },
  })
}
